import { render } from "./Administrador.vue?vue&type=template&id=bdccd962"
import script from "./Administrador.vue?vue&type=script&lang=js"
export * from "./Administrador.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__